import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import moment from "moment";

if (environment.production) {
    enableProdMode();
}

moment.locale('pl', {
    week: {
        dow: 1 // Set the first day of the week to Monday
    }
});

platformBrowserDynamic().bootstrapModule(AppModule);